<template>
  <div class="article-list">
    <div v-for="item in pageData.content" class="content-item">
      <article-list  :article=item></article-list>
    </div>
  </div>
</template>

<script>

  import {articleList} from "./../../api/api"
  import ArticleList from "./ArticleList";

  export default {
    name: "HomeArticleList",
    props: {
      page: 0,
      searchAction: false,
      queryVo:{}
    },
    components: {ArticleList},
    methods: {
      articleList: function (params) {
        const res = articleList(params);
        res.then(x => {
          console.log(x);
          this.pageData = x.data.data;
          console.log("searchResult-searchAction:",this.pageData.last);
          this.$emit('searchResult', this.pageData.last, this.pageData.number);
          debugger;
        })
      },
      searchQuery: function(page, size) {
        console.log("searchQuery:",page, size, this.page, this.searchAction, this.pageable.size, this.queryVo);
        this.articleList({
          page: page,
          size: size,
          sort: "id,desc",
          keyword: this.queryVo.keyword,
          startTime: this.queryVo.startTime,
          endTime: this.queryVo.endTime
        })
      }
    },
    created() {
      this.articleList({
        page: this.page,
        size: this.pageable.size,
        sort: 'id,desc'
      });
      // this.tesUrlPost()
      // this.tesUrlPostBody()
    },
    watch: {
      /*searchAction(now, before){
        /!* 监听number的变化*!/
        console.log("searchAction",now, before);
        console.log("searchAction",this.searchAction);
        this.searchAction = false;
        console.log("searchAction1",this.searchAction);
        this.$emit('searchResult', this.searchAction);
        this.articleList({
          page: this.page,
          keyword: this.queryVo.keyword,
          startTime: this.queryVo.startTime,
          endTime: this.queryVo.endTime
        })
      }*/
    },
    data: function () {
      return {
        article: {
          id: null,
          title: "docker--学习一",
          pic: "./../../../static/pic/docker-1.png",
          introduces: "docker的目标提供轻量的建模方式，职责的逻辑分离，快速高效的开发生命周期，鼓励使用面向服务架构",
          content: "docker提供轻量的建模方式：容易上手，用户只需要用几分钟就可以把自己的程序docker化，大多数docker容器只需要不到一秒就可运行起来，由于去除了管理程度的开销，docker容器拥有非常高的性能，同时同一台宿主机中也可运行更多的容器，使用户可以尽可能的充分利用系统资源；\n" +
            "职责的逻辑分离：使用docker开发人员只要关系容器中运行的应用程序，而运维人员只需要关心如何管理容器，docker设计的目的就是要加强开发人员写代码和开发环境与应用程序要部署到开发环境的一致性；\n" +
            "快速高效的开发生命周期：docker的目标之一是缩短代码从开发测试部署上线运行的生命周期，让你们的应用程序具备可移植性；\n" +
            "鼓励使用面向服务的架构：docker推荐使用单个容器只运行一个应用程序或者进程，这样就形成一个分布式的应用模型，在这种模型下应用程序或者服务都可以表现为一系列内部互联的容器，从而使分布式部署应用程序扩展和调试应用程序变得简单，这就像我们在开发中常用的思想，高内聚低耦合单一人任务，这样就能够避免，在同一服务器上部署不同服务时，可能带来的服务之间的互相影响，这样在运行过程中出现问题也比较容易定位问题所在；",
          showDetails: false
        },
        pageable: {
          size: 3
        },
        pageData: {
          content:[],
          first: true,
          last: false,
          number: 0,
          size: 0,
          numberOfElements: 0,
          totalElements: 0,
          totalPages: 0
        },
        list1: [
          {
            id: null,
            title: "docker--学习一",
            pic: "./../../../static/pic/docker-1.png",
            introduces: "docker的目标提供轻量的建模方式，职责的逻辑分离，快速高效的开发生命周期，鼓励使用面向服务架构",
            content: "docker提供轻量的建模方式：容易上手，用户只需要用几分钟就可以把自己的程序docker化，大多数docker容器只需要不到一秒就可运行起来，由于去除了管理程度的开销，docker容器拥有非常高的性能，同时同一台宿主机中也可运行更多的容器，使用户可以尽可能的充分利用系统资源；\n" +
              "职责的逻辑分离：使用docker开发人员只要关系容器中运行的应用程序，而运维人员只需要关心如何管理容器，docker设计的目的就是要加强开发人员写代码和开发环境与应用程序要部署到开发环境的一致性；\n" +
              "快速高效的开发生命周期：docker的目标之一是缩短代码从开发测试部署上线运行的生命周期，让你们的应用程序具备可移植性；\n" +
              "鼓励使用面向服务的架构：docker推荐使用单个容器只运行一个应用程序或者进程，这样就形成一个分布式的应用模型，在这种模型下应用程序或者服务都可以表现为一系列内部互联的容器，从而使分布式部署应用程序扩展和调试应用程序变得简单，这就像我们在开发中常用的思想，高内聚低耦合单一人任务，这样就能够避免，在同一服务器上部署不同服务时，可能带来的服务之间的互相影响，这样在运行过程中出现问题也比较容易定位问题所在；",
            showDetails: false
          }
        ],
        getResponse: {
          status: 200,
          data: {}
        }
      }
    }
  }
</script>

<style scoped>
  div, img, h3, p {
    margin: 0;
    padding: 0;
  }

  .article-list {
    display: inline-block;
    margin: 5px 10px;
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .article-list .content-item {
    display: inline-block;
    float: left;
    margin: 5px;
    width: 31.5%;
    overflow: hidden;
    height: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/articles/HomeArticleList.vue